export const COLLECTION_CONTACT_MESSAGE = 'contactMessage';
